import { useEffect } from 'react';
import fetchProfile from './fetchProfile';

export default function useFetchProfile() {
  useEffect(() => {
    fetchProfile();
  }, []);
}
